import { render, staticRenderFns } from "./orderManageList.vue?vue&type=template&id=16629f07&scoped=true"
import script from "./orderManageList.vue?vue&type=script&lang=js"
export * from "./orderManageList.vue?vue&type=script&lang=js"
import style0 from "./orderManageList.vue?vue&type=style&index=0&id=16629f07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16629f07",
  null
  
)

export default component.exports